<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Habilitados ({{ activeArrData.length }})">
    <div class="px-4 row status" *ngIf="!isVirtualAgency">
      <div class="my-3 col-lg-6 col-xl-4"
        [ngClass]="{'col-12, col-lg-12 col-xl-12': isSpecial && i === 0 || isSpecial && i === 4}"
        *ngFor="let card of activeArrData, index as i">
        <mat-card fxLayout="column" class="has-outline-menu card" fxLayout.lt-sm="row"
          fxLayoutAlign.lt-sm="start center">
          <div class="vs-crud-menu">
            <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Card" (click)="editCard(card)">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
              [matTooltip]="card.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"
              (click)="changeStatusFromEnable(card, card.status)">
              <mat-icon>{{ card.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(card)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
          <!-- <div class="order">
            <p class="fw-bold m-0">{{card.orderId}}</p>
          </div> -->
          <div class="text-center" fxFlex.lt-sm="1 1 64px">
            <img [src]="card.img" width="60" height="50" class="my-3">
          </div>
          <div class="text-center">
            <div class="titulo_icono mb-3 fw-bold">
              <span>{{card.title}}</span>
            </div>
            <div class="subtitulo_icono">
              <span>
                {{card.subTitle | maxLength}}
              </span>
            </div>
          </div>
          <div class="url-btn">
            <mat-icon *ngIf="card.activeButton" class="mat-icon c-icon">smart_button</mat-icon>
            <mat-icon *ngIf="card.url" class="mat-icon c-icon">language</mat-icon>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center" *ngIf="isVirtualAgency">
      <div class="content">
        <div class="d-flex flex-column p-3">
          <ng-container *ngFor="let card of activeArrData">
            <div class="operations-card has-outline-menu" *ngIf="card.column === 1"
                 [ngClass]="{'flex-column text-center': card.activeButton === 1 || card.typeId === 1}">
              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Card" (click)="editCard(card)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="card.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"
                        (click)="changeStatusFromEnable(card, card.status)">
                  <mat-icon>{{ card.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(card)">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
              <img [src]="card.img" alt="card-img" [ngClass]="{'my-3': card.activeButton === 1 || card.typeId === 1}">
              <div class="d-flex flex-column justify-content-center">
                <h3 [ngClass]="{'my-2': card.activeButton === 1 || card.typeId === 1}">{{card.title}}</h3>
                <p *ngIf="card.subTitle">{{card.subTitle}}</p>
              </div>
              <div *ngIf="card.typeId === 1" class="d-flex flex-column justify-content-center">
                <div class="w-100">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{card.nameButton || 'Codigo'}}</mat-label>
                    <input matInput maxlength="12" required placeholder="Ingresa tu código aquí" type="text" disabled>
                    <mat-error *ngIf="false">El número es <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="false">El número es <strong>inválido</strong>.</mat-error>
                  </mat-form-field>
                </div>
                <button type="button" mat-flat-button color="primary">
                  Consultar
                </button>
              </div>
<!--              <button type="button" mat-flat-button color="primary" *ngIf="card.activeButton">-->
<!--                {{card.nameButton}}-->
<!--              </button>-->
              <div class="url-btn">
                <mat-icon *ngIf="card.activeButton" class="mat-icon c-icon">smart_button</mat-icon>
                <mat-icon *ngIf="card.url" class="mat-icon c-icon">language</mat-icon>
                <mat-icon *ngIf="card.typeId === 1" class="mat-icon c-icon">keyboard</mat-icon>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="d-flex flex-column p-3">
<!--          l : ejemplo de caso de form-->
          <ng-container *ngFor="let card of activeArrData">
            <div class="operations-card has-outline-menu" *ngIf="card.column === 2"
                 [ngClass]="{'flex-column text-center ': card.activeButton === 1 || card.typeId === 1}">
              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Card" (click)="editCard(card)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="card.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"
                        (click)="changeStatusFromEnable(card, card.status)">
                  <mat-icon>{{ card.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(card)">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
              <img [src]="card.img" alt="card-img" [ngClass]="{'mx-0': card.activeButton === 1 || card.typeId === 1}">
              <div class="d-flex flex-column justify-content-center">
                <h3 [ngClass]="{'my-2': card.activeButton === 1 || card.typeId === 1}">{{card.title}}</h3>
                <p *ngIf="card.subTitle">{{card.subTitle}}</p>
              </div>
              <div *ngIf="card.typeId === 1" class="d-flex flex-column justify-content-center">
                <div class="w-100">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{card.nameButton || 'Codigo'}}</mat-label>
                    <input matInput maxlength="12" required placeholder="Ingresa tu código aquí" type="text" disabled>
                    <mat-error *ngIf="false">El número es <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="false">El número es <strong>inválido</strong>.</mat-error>
                  </mat-form-field>
                </div>
                <button type="button" mat-flat-button color="primary">
                  Consultar
                </button>
              </div>
<!--              <button type="button" mat-flat-button color="primary" *ngIf="card.activeButton">-->
<!--                {{card.nameButton}}-->
<!--              </button>-->
              <div class="url-btn">
                <mat-icon *ngIf="card.activeButton" class="mat-icon c-icon">smart_button</mat-icon>
                <mat-icon *ngIf="card.url" class="mat-icon c-icon">language</mat-icon>
                <mat-icon *ngIf="card.typeId === 1" class="mat-icon c-icon">keyboard</mat-icon>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Deshabiltados ({{ inactiveArrData.length }})">
    <div class="px-4 row disabled-content" *ngIf="!isVirtualAgency">
      <div class="my-3 col-12 col-md-6 col-lg-4" *ngFor="let card of inactiveArrData, index as i">
        <mat-card fxLayout="column" class="has-outline-menu" fxLayout.lt-sm="row" fxLayoutAlign.lt-sm="start center"
          style="height: 226px">
          <div class="vs-crud-menu">
            <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
              [matTooltip]="card.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"
              (click)="changeStatusFromDisable(card, card.status)">
              <mat-icon>{{ card.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(card)">
              <mat-icon>delete_forever</mat-icon>
            </button>
          </div>
          <!-- <div class="order">
            <p class="fw-bold m-0">{{card.orderId}}</p>
          </div> -->
          <div class="text-center" fxFlex.lt-sm="1 1 64px">
            <img [src]="card.img" width="60" height="50" class="my-3"
              onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
          </div>
          <div class="text-center">
            <div class="titulo_icono mb-3 fw-bold">
              <span>{{card.title}}</span>
            </div>
            <div class="subtitulo_icono">
              <span>
                {{card.subTitle | maxLength}}
              </span>
            </div>
          </div>
          <div class="url-btn">
            <mat-icon *ngIf="card.activeButton" class="mat-icon c-icon">smart_button</mat-icon>
            <mat-icon *ngIf="card.url" class="mat-icon c-icon">language</mat-icon>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center disabled-content" *ngIf="isVirtualAgency">
      <div class="content">
        <div class="d-flex flex-column p-3">
          <ng-container *ngFor="let card of inactiveArrData">
            <div class="operations-card has-outline-menu" *ngIf="card.column === 1"
                 [ngClass]="{'flex-column text-center': card.activeButton === 1 || card.typeId === 1}">
              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="card.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"
                        (click)="changeStatusFromEnable(card, card.status)">
                  <mat-icon>{{ card.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(card)">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
              <img [src]="card.img" alt="card-img" [ngClass]="{'my-3': card.activeButton === 1 || card.typeId === 1}">
              <div class="d-flex flex-column justify-content-center">
                <h3 [ngClass]="{'my-2': card.activeButton === 1 || card.typeId === 1}">{{card.title}}</h3>
                <p *ngIf="card.subTitle">{{card.subTitle}}</p>
              </div>
              <div *ngIf="card.typeId === 1" class="d-flex flex-column justify-content-center">
                <div>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{card.nameButton || 'Codigo'}}</mat-label>
                    <input matInput maxlength="12" required placeholder="Ingresa tu código aquí" type="text" disabled>
                    <mat-error *ngIf="false">El número es <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="false">El número es <strong>inválido</strong>.</mat-error>
                  </mat-form-field>
                </div>
                <button type="button" mat-flat-button color="primary">
                  Consultar
                </button>
              </div>
              <button type="button" mat-flat-button color="primary" *ngIf="card.activeButton">
                {{card.nameButton}}
              </button>
              <div class="url-btn">
                <mat-icon *ngIf="card.activeButton" class="mat-icon c-icon">smart_button</mat-icon>
                <mat-icon *ngIf="card.url" class="mat-icon c-icon">language</mat-icon>
                <mat-icon *ngIf="card.typeId === 1" class="mat-icon c-icon">keyboard</mat-icon>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="d-flex flex-column p-3">
          <!--          l : ejemplo de caso de form-->
          <ng-container *ngFor="let card of inactiveArrData">
            <div class="operations-card has-outline-menu" *ngIf="card.column === 2"
                 [ngClass]="{'flex-column text-center ': card.activeButton === 1 || card.typeId === 1}">
              <div class="vs-crud-menu">
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                        [matTooltip]="card.status === 'Activo' ? 'Deshabilitar Card' :  'Habilitar Card'"
                        (click)="changeStatusFromEnable(card, card.status)">
                  <mat-icon>{{ card.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <button type="button" [disabled]="!mantenienceSection" type="button" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Card" (click)="delete(card)">
                  <mat-icon>delete_forever</mat-icon>
                </button>
              </div>
              <img [src]="card.img" alt="card-img" [ngClass]="{'mx-0': card.activeButton === 1 || card.typeId === 1}">
              <div class="d-flex flex-column justify-content-center">
                <h3 [ngClass]="{'my-2': card.activeButton === 1 || card.typeId === 1}">{{card.title}}</h3>
                <p *ngIf="card.subTitle">{{card.subTitle}}</p>
              </div>
              <div *ngIf="card.typeId === 1" class="d-flex flex-column justify-content-center">
                <div>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{card.nameButton || 'Codigo'}}</mat-label>
                    <input matInput maxlength="12" required placeholder="Ingresa tu código aquí" type="text" disabled>
                    <mat-error *ngIf="false">El número es <strong>requerido</strong>.</mat-error>
                    <mat-error *ngIf="false">El número es <strong>inválido</strong>.</mat-error>
                  </mat-form-field>
                </div>
                <button type="button" mat-flat-button color="primary">
                  Consultar
                </button>
              </div>
              <button type="button" mat-flat-button color="primary" *ngIf="card.activeButton">
                {{card.nameButton}}
              </button>
              <div class="url-btn">
                <mat-icon *ngIf="card.activeButton" class="mat-icon c-icon">smart_button</mat-icon>
                <mat-icon *ngIf="card.url" class="mat-icon c-icon">language</mat-icon>
                <mat-icon *ngIf="card.typeId === 1" class="mat-icon c-icon">keyboard</mat-icon>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
